import Site2 from '@/shared/app/model/templating/Site2';
import { DishesMock } from '@/shared/data/mocks/dishes/dishes.mock';
import { notInProduction } from '@/shared/data/mocks/not-in-production';

import bgOffreComplete from './image/offre_complete.webp';

const mockSandwichs = new DishesMock({
  maxDishes: 4,
  minDishes: 3,
  maxOrigins: 0,
});

const site: Site2 = {
  pages: [
    {
      templateGetter() {
        const l1Top = '12%';
        const l2Top = '53.5%';
        const colWidth = '21.5%';
        const blockHeight = '23.8%';

        return {
          component: 'Box',
          config: {
            background: true,
            backgroundImage: true,
            backgroundImagePath: bgOffreComplete,
          },
          slots: {
            ext: {
              component: 'AutoAbsolute',
              config: {
                sandwichsTop: l1Top,
                sandwichsLeft: '2.5%',
                sandwichsWidth: colWidth,
                sandwichsHeight: blockHeight,
                viennoiseriesLeft: '2.5%',
                viennoiseriesTop: l2Top,
                viennoiseriesWidth: colWidth,
                viennoiseriesHeight: blockHeight,
                platsTop: l1Top,
                platsLeft: '27%',
                platsWidth: colWidth,
                platsHeight: blockHeight,
                confiseriesTop: l2Top,
                confiseriesLeft: '27%',
                confiseriesWidth: colWidth,
                confiseriesHeight: blockHeight,
                boissonsTop: l1Top,
                boissonsLeft: '51.4%',
                boissonsWidth: colWidth,
                boissonsHeight: blockHeight,
                acoteTop: l2Top,
                acoteLeft: '51.4%',
                acoteWidth: colWidth,
                acoteHeight: blockHeight,
                dessertsTop: l1Top,
                dessertsLeft: '75.8%',
                dessertsWidth: colWidth,
                dessertsHeight: '61%',
              },
              slots: {
                sandwichs: {
                  component: 'Mock',
                },
                viennoiseries: {
                  component: 'Mock',
                },
                plats: {
                  component: 'Mock',
                },
                confiseries: {
                  component: 'Mock',
                },
                boissons: {
                  component: 'Mock',
                },
                acote: {
                  component: 'Mock',
                },
                desserts: {
                  component: 'Mock',
                },
              },
            },
          },
        };
      },
      datasets: {
        sandwichs: 'itec_boisfleury_sandwichs',
      },
      default: {
        sandwichs: notInProduction(mockSandwichs.make()),
      },
      init: async () => {
        //
      },
    },
  ],
};

export default site;
